import React, { useEffect, useReducer } from "react";
import {
  applyLeaveByEmployee,
  getEmployeeListByManager,
  getShortLeaveConfig,
  getEmployeeLeaves,
} from "../../config/services/employeeServices";
import { DatePicker, Select, TimePicker } from "antd";
import moment from "moment";
import { Modal } from "react-bootstrap";
import "./ApplyLeave.css";
import {
  disabledLeaveEndDate,
  disabledStartDate,
  format,
  Half_Casual_Leave,
  Half_Compensatory_Off,
  Half_Earned_Leave,
  HALF_LEAVE_ARRAY,
  Half_Leave_Short_Leave,
  Half_LWP,
  Half_Other,
  Half_Sick_Leave,
  Half_WFH,
  halfLeaveValues,
  LEAVE_ARRAY,
  leaveValue,
  removeSessionStorage,
  SHORT_DAY_LEAVE,
  Short_Day_Leave,
} from "./Constants";
import { ErrorMessage, reducer, Toastify, type } from "../helper/Constant";
import { handleValidation } from "./LeaveValidation";
import { Loader } from "../svg";
import TextEditor from "../../hoc/textEditor/TextEditor";
import { EditorState, convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import ResponseFilter from "../../ResponseFilter";
import _ from "lodash";
import UploadDocument from "./uploadDocument";
const { Option } = Select;
const dateFormat = "DD-MM-YYYY";
const initialState = {
  miniLoader: false,
  leaveMsg: "",
  reasonErMsg: "",
  leaveErMsg: "",
  exceedMsg: "",
  startDate: "",
  endDate: "",
  startDateErrMsg: "",
  applyDateErrMsg: "",
  endDateErrMsg: "",
  uploadDocumentError: "",
  endOpen: false,
  empDetails: [],
  value: "",
  emails: [],
  emailError: "",
  inputEmail: "",
  halfOfTheDay: "",
  halfOfTheDayErrMsg: "",
  resLeaveMsg: false,
  resFailMsg: false,
  shortDayTo: "",
  shortDayFrom: "",
  shortDayToErrorMsg: "",
  shortDayFromErrorMsg: "",
  leaveType: "",
  responseMessage: "",
  editorState: EditorState.createEmpty(),
  employeeList: [],
  uploadDocument: [],
  uploadDocumentName: [],
  uploadDocumentErrMsg: "",
  shortLeaveType: "",
  shortLeaveTypeErrMsg: "",
  availableShortLeaveTypes: [],
  loadingShortLeaveConfig: false,
  // Sandwich leave state
  showSandwichModal: false,
  sandwichInfo: null,
  sandwichConfig: null,
  isSandwichConfirmed: false,
};

function ApplyLeave(props) {
  const [state, dispatch] = useReducer(reducer, initialState);
  const dashboardStartDate = sessionStorage.getItem(
    "dashboard_leave_startDate"
  );
  const dashboardLeaveType = sessionStorage.getItem("dashboard_leaveType");
  const {
    assignedClientOff,
    assignedBereavementLeaves,
    assignedPaternalLeave,
    ResData,
  } = props;
  const {
    miniLoader,
    leaveMsg,
    reasonErMsg,
    leaveErMsg,
    exceedMsg,
    startDate,
    endDate,
    startDateErrMsg,
    applyDateErrMsg,
    endDateErrMsg,
    uploadDocumentError,
    endOpen,
    empDetails,
    emails,
    inputEmail,
    halfOfTheDay,
    halfOfTheDayErrMsg,
    resLeaveMsg,
    resFailMsg,
    shortDayTo,
    shortDayFrom,
    shortDayToErrorMsg,
    shortDayFromErrorMsg,
    leaveType,
    responseMessage,
    editorState,
    employeeList,
    uploadDocument,
    uploadDocumentName,
    uploadDocumentErrMsg,
    shortLeaveType,
    shortLeaveTypeErrMsg,
    availableShortLeaveTypes,
    loadingShortLeaveConfig,
    showSandwichModal,
    sandwichInfo,
    sandwichConfig,
    isSandwichConfirmed,
  } = state;

  const onEditorStateChange = (editorState) => {
    dispatch({
      type: type,
      payload: {
        editorState: editorState,
        reasonErMsg: "",
      },
    });
  };

  useEffect(() => {
    getEmployeeListByManager("").then((res) => {
      let { status } = ResponseFilter(res);
      if (status) {
        dispatch({
          type: type,
          payload: {
            employeeList: res.data.responseData.employeesList,
          },
        });
      }
    });
  }, []);

  useEffect(() => {
    if (leaveType === Short_Day_Leave || (!leaveType && dashboardLeaveType === Short_Day_Leave)) {
      dispatch({
        type: type,
        payload: {
          loadingShortLeaveConfig: true,
        },
      });

      getShortLeaveConfig()
        .then((res) => {
          if (res.data.statusCode === 1) {
            const config = res.data.responseData.list;
            const types = [];
            if (config.enableCasualLeave) {
              types.push({ value: 1, label: 'Casual Leave' });
            }
            if (config.enableEarnedLeave) {
              types.push({ value: 2, label: 'Earned Leave' });
            }
            if (config.enableSickLeave) {
              types.push({ value: 3, label: 'Sick Leave' });
            }
            if (config.enableLwp) {
              types.push({ value: 4, label: 'Leave Without Pay' });
            }

            dispatch({
              type: type,
              payload: {
                availableShortLeaveTypes: types,
                loadingShortLeaveConfig: false,
              },
            });
          }
        })
        .catch((error) => {
          console.error("Failed to load short leave config", error);
          dispatch({
            type: type,
            payload: {
              loadingShortLeaveConfig: false,
            },
          });
        });
    } else {
      // Reset when not Short Day Leave
      dispatch({
        type: type,
        payload: {
          shortLeaveType: "",
          shortLeaveTypeErrMsg: "",
          availableShortLeaveTypes: [],
        },
      });
    }
  }, [leaveType, dashboardLeaveType]);


  const handleApiResponse = (res) => {
    if (dashboardStartDate) {
      dispatch({
        type: type,
        payload: {
          endDate: "",
          emails: [],
          editorState: EditorState.createEmpty(),
          startDate: "",
        },
      });
    }
    if (res.data.statusCode === 1) {
      dispatch({
        type: type,
        payload: {
          resLeaveMsg: true,
          miniLoader: false,
        },
      });
      setTimeout(() => {
        dispatch({
          type: type,
          payload: {
            resLeaveMsg: false,
          },
        });
        window.location.href = "/leaves";
      }, 2000);
    } else {
      dispatch({
        type: type,
        payload: {
          loader: false,
          miniLoader: false,
          resFailMsg: true,
          responseMessage: res.data.error.responseMessage,
        },
      });
      setTimeout(() => {
        dispatch({
          type: type,
          payload: {
            resFailMsg: false,
            responseMessage: "",
          },
        });
      }, 2000);
    }
  };

  const handleSubmit = async (e) => {
    dispatch({
      type: type,
      payload: {
        uploadDocumentErrMsg: "",
      },
    });
    e.preventDefault();
    if (
      handleValidation({
        empDetails: empDetails,
        emails: emails,
        inputEmail: inputEmail,
        leaveMsg: leaveMsg,
        editorState: editorState,
        leaveType: leaveType,
        startDate: startDate,
        endDate: endDate,
        dispatch: dispatch,
        halfOfTheDay: halfOfTheDay,
        shortDayFrom: shortDayFrom,
        shortDayTo: shortDayTo,
        shortLeaveType: shortLeaveType,
        totalRemainingLeave: props?.totalRemainingLeave,
        dashboardLeaveType: dashboardLeaveType,
        dashboardStartDate: dashboardStartDate,
        assignedClientOff,
        assignedBereavementLeaves,
        assignedPaternalLeave,
        ResData,
        uploadDocument: uploadDocument,
        isSandwichConfirmed: isSandwichConfirmed
      })
    ) {
      // Final Sandwich Check
      const targetSD = startDate || (dashboardStartDate ? moment(dashboardStartDate, [dateFormat, moment.ISO_8601]).toISOString() : "");
      const targetED = endDate || targetSD;
      const targetLT = leaveType || dashboardLeaveType;

      if (!isSandwichConfirmed && targetSD && targetED && targetLT) {
        const info = await checkSandwichLeave(targetSD, targetED, targetLT);
        if (info) {
          dispatch({
            type: type,
            payload: {
              sandwichInfo: info,
              showSandwichModal: true,
              isSandwichConfirmed: false,
            },
          });
          return;
        }
      }

      dispatch({
        type: type,
        payload: {
          miniLoader: true,
        },
      });

      let startD = moment(targetSD).toDate();
      let endD = moment(targetED).toDate();

      // Sandwich Leave Adjustment
      let finalStartDate = moment(startD).format('YYYY-MM-DD');
      let finalEndDate = moment(endD).format('YYYY-MM-DD');

      if (isSandwichConfirmed && sandwichInfo?.type === 'monday' && sandwichInfo?.weekendDates?.[0]) {
        finalStartDate = sandwichInfo.weekendDates[0]; // Saturday
      } else if (isSandwichConfirmed && sandwichInfo?.type === 'friday' && sandwichInfo?.weekendDates?.[1]) {
        finalEndDate = sandwichInfo.weekendDates[1]; // Sunday
      }
      let leaveReason = draftToHtml(
        convertToRaw(editorState.getCurrentContent())
      );
      let formData = new FormData();
      formData.append("leaveMsg", leaveReason);
      formData.append(
        "leaveType",
        leaveType && !dashboardLeaveType
          ? +leaveType
          : leaveType
            ? +leaveType
            : +dashboardLeaveType
      );
      formData.append("from", shortDayFrom);
      formData.append("to", shortDayTo);
      formData.append("shortLeaveType", shortLeaveType ? +shortLeaveType : "");
      formData.append(
        "startDate",
        !leaveType && dashboardStartDate
          ? dashboardStartDate
          : leaveType && !startDate && dashboardStartDate
            ? dashboardStartDate
            : finalStartDate
      );
      formData.append(
        "endDate",
        leaveType &&
          !dashboardStartDate &&
          Half_Leave_Short_Leave.includes(leaveType)
          ? finalStartDate
          : leaveType &&
            dashboardLeaveType &&
            startDate === "" &&
            Half_Leave_Short_Leave.includes(leaveType)
            ? dashboardStartDate
            : !leaveType &&
              dashboardLeaveType &&
              startDate === "" &&
              Half_Leave_Short_Leave.includes(dashboardLeaveType)
              ? dashboardStartDate
              : leaveType && dashboardLeaveType && startDate
                ? finalStartDate
                : finalEndDate
      );
      formData.append("emailInCC", JSON.stringify(emails));
      formData.append(
        "halfOfTheDay",
        leaveType === Half_Casual_Leave ||
          leaveType === Half_Earned_Leave ||
          leaveType === Half_Sick_Leave ||
          leaveType === Half_LWP ||
          leaveType === Half_Compensatory_Off ||
          leaveType === Half_WFH ||
          dashboardLeaveType === Half_Casual_Leave ||
          dashboardLeaveType === Half_Earned_Leave ||
          dashboardLeaveType === Half_Sick_Leave ||
          dashboardLeaveType === Half_LWP ||
          dashboardLeaveType === Half_Compensatory_Off ||
          dashboardLeaveType === Half_WFH
          ? halfOfTheDay
          : 0
      );
      uploadDocument.forEach((file) => {
        formData.append("leaveDoc", file);
      });
      applyLeaveByEmployee(formData).then((res) => {
        handleApiResponse(res);
        removeSessionStorage();
      });
    }
  };

  const handleSelectChange = (e) => {
    dispatch({
      type: type,
      payload: {
        leaveType: e,
        leaveErMsg: "",
        exceedMsg: "",
        startDateErrMsg: "",
        endDateErrMsg: "",
        applyDateErrMsg: "",
        uploadDocumentError: "",
        reasonErMsg: "",
        halfOfTheDayErrMsg: "",
        shortDayFromErrorMsg: "",
        shortDayToErrorMsg: "",
        shortLeaveTypeErrMsg: "",
        isSandwichConfirmed: false,
      },
    });
  };

  const handleCheckInChange = (checkIn, checkInString) => {
    dispatch({
      type: type,
      payload: {
        shortDayFrom: moment.duration(checkInString).asSeconds(),
        shortDayFromErrorMsg: "",
      },
    });
  };

  // Sandwich Leave Detection Logic
  const checkSandwichLeave = async (selectedStartDate, selectedEndDate, selectedLeaveType) => {
    // Only check for full leave types (not half leaves, short leaves)
    const fullLeaveTypes = [1, 2, 3, 4, 5, 11, 13, 16, 17, 18];
    if (!fullLeaveTypes.includes(+selectedLeaveType)) {
      return null;
    }

    try {
      // Fetch sandwich config from API
      const response = await getShortLeaveConfig();
      if (response?.data?.statusCode !== 1) return null;

      const configSandwich = response.data.responseData.list;

      // If sandwichLeave is missing or all false, the feature is effectively disabled for all types
      const isEnabled = shouldCheckSandwich(selectedLeaveType, configSandwich);
      if (!isEnabled) {
        return null;
      }

      const start = moment(selectedStartDate).startOf('day');
      const end = moment(selectedEndDate).startOf('day');

      // First: Check if any of the selected dates already have approved leaves
      // If yes, skip the sandwich popup (user is likely re-applying or there's overlap)
      const hasExistingLeaveOnSelectedDates = await checkIfSelectedDatesHaveApprovedLeaves(start, end);
      if (hasExistingLeaveOnSelectedDates) {
        return null;
      }

      // Scenario 1: Friday to Monday continuous leave (spans weekend within single application)
      // If start is Friday and end is Monday or later (same or next week), weekend is sandwiched
      if (start.day() === 5) { // Friday
        const daysDiff = end.diff(start, 'days');
        // If applying from Friday and at least 3 days (Fri -> Sat -> Sun -> Mon), it's a sandwich
        if (daysDiff >= 3 && end.day() >= 1 && end.day() <= 5) {
          const sat = moment(start).add(1, 'day');
          const sun = moment(start).add(2, 'days');
          return {
            type: 'continuous',
            message: `Your leave spans from Friday (${start.format('DD MMM')}) to ${end.format('DD MMM')} (${end.format('dddd')}). This is a Sandwich Leave scenario. Weekend days (${sat.format('DD MMM')} & ${sun.format('DD MMM')}) will be included in your request.`,
            weekendDates: [
              sat.format('YYYY-MM-DD'), // Saturday
              sun.format('YYYY-MM-DD')   // Sunday
            ]
          };
        }
      }

      // Scenario 2: Monday selected + check for existing Friday leave
      if (start.day() === 1) {
        const prevFriday = moment(start).subtract(3, 'days');
        const hasLeaveOnFriday = await checkExistingLeaveOnDate(prevFriday, selectedLeaveType);

        if (hasLeaveOnFriday) {
          const sat = moment(start).subtract(2, 'days');
          const sun = moment(start).subtract(1, 'day');
          return {
            type: 'monday',
            message: `You have an approved leave on ${prevFriday.format('DD MMM')} (Friday). This is a Sandwich Leave scenario. Weekend days (${sat.format('DD MMM')} & ${sun.format('DD MMM')}) will be included in your request.`,
            weekendDates: [
              sat.format('YYYY-MM-DD'), // Saturday
              sun.format('YYYY-MM-DD')   // Sunday
            ]
          };
        }
      }

      // Scenario 3: Friday selected (or range ends on Friday) + check for existing Monday leave
      if (end.day() === 5) {
        const nextMonday = moment(end).add(3, 'days');
        const hasLeaveOnMonday = await checkExistingLeaveOnDate(nextMonday, selectedLeaveType);

        if (hasLeaveOnMonday) {
          const sat = moment(end).add(1, 'day');
          const sun = moment(end).add(2, 'days');
          return {
            type: 'friday',
            message: `You have an approved leave on ${nextMonday.format('DD MMM')} (Monday). This is a Sandwich Leave scenario. Weekend days (${sat.format('DD MMM')} & ${sun.format('DD MMM')}) will be included in your request.`,
            weekendDates: [
              sat.format('YYYY-MM-DD'), // Saturday
              sun.format('YYYY-MM-DD')  // Sunday
            ]
          };
        }
      }
    } catch (error) {
      console.error('Error checking sandwich leave:', error);
    }

    return null;
  };

  // Helper to check if any of the selected dates already have approved leaves
  const checkIfSelectedDatesHaveApprovedLeaves = async (startDate, endDate) => {
    const employeeId = localStorage.getItem("employeeId");
    try {
      const year = startDate.year();
      const params = { year, status: 2, count: 1000, pageNo: 0, userId: employeeId };
      const response = await getEmployeeLeaves(params);

      if (response?.data?.statusCode === 1) {
        const resData = response.data.responseData;
        const leaves = resData?.leavesDetails?.leaveList || resData?.leaves || [];

        // Check if any of the selected dates overlap with existing approved leaves
        const fullLeaveTypes = [1, 2, 3, 4, 5, 11, 13, 16, 17, 18];

        return leaves.some(leave => {
          if (!fullLeaveTypes.includes(+leave.leaveType)) return false;

          const leaveStart = moment(leave.startDate, [moment.ISO_8601, dateFormat]).startOf('day');
          const leaveEnd = moment(leave.endDate, [moment.ISO_8601, dateFormat]).endOf('day');

          // Check if any date in the selected range overlaps with this leave
          let current = moment(startDate);
          while (current <= endDate) {
            if (current.isBetween(leaveStart, leaveEnd, 'day', '[]')) {
              return true;
            }
            current.add(1, 'day');
          }
          return false;
        });
      }
    } catch (error) {
      console.error('Error checking existing leaves on selected dates:', error);
    }
    return false;
  };

  const shouldCheckSandwich = (leaveType, config) => {
    const sandwichConfig = config?.sandwichLeave || {};
    switch (+leaveType) {
      case 1: return sandwichConfig.enableCasualLeave;
      case 2: return sandwichConfig.enableEarnedLeave;
      case 3: return sandwichConfig.enableSickLeave;
      case 4: return sandwichConfig.enableLwp;
      case 5: return sandwichConfig.enableCompensatoryOff;
      case 11: return sandwichConfig.enableWorkFromHome;
      case 13: return sandwichConfig.enableOtherLeave;
      case 16: return sandwichConfig.enableClientOff;
      case 17: return sandwichConfig.enablePaternalLeave;
      case 18: return sandwichConfig.enableBereavementLeave;
      default: return false;
    }
  };

  const checkExistingLeaveOnDate = async (date, targetType) => {
    const employeeId = localStorage.getItem("employeeId");
    try {
      const year = date.year();
      const params = { year, status: 2, count: 1000, pageNo: 0, userId: employeeId };
      const response = await getEmployeeLeaves(params);

      if (response?.data?.statusCode === 1) {
        const resData = response.data.responseData;
        const leaves = resData?.leavesDetails?.leaveList || resData?.leaves || [];

        return leaves.some(leave => {
          // Robustly parse dates, trying multiple formats
          const leaveStart = moment(leave.startDate, [moment.ISO_8601, dateFormat]).startOf('day');
          const leaveEnd = moment(leave.endDate, [moment.ISO_8601, dateFormat]).endOf('day');
          const matchesDate = date.isBetween(leaveStart, leaveEnd, 'day', '[]');

          // Full leave types are usually the ones that trigger sandwiches
          const fullLeaveTypes = [1, 2, 3, 4, 5, 11, 13, 16, 17, 18];
          const isFullLeave = fullLeaveTypes.includes(+leave.leaveType);

          return matchesDate && isFullLeave;
        });
      }
    } catch (error) {
      console.error('Error checking existing leave:', error);
    }
    return false;
  };

  const handleCheckOutChange = (checkOut, checkOutString) => {
    dispatch({
      type: type,
      payload: {
        shortDayTo: moment.duration(checkOutString).asSeconds(),
        shortDayToErrorMsg: "",
      },
    });
  };

  const onStartChange = (value) => {
    const newStartDate = moment(value).toISOString();
    onChangeDate("startDate", newStartDate, true); // Pass reset flag

    // Check for sandwich leave scenario after setting start date
    const targetEndDate = endDate || newStartDate;
    const currentLT = leaveType || dashboardLeaveType;
    if (currentLT && newStartDate && targetEndDate) {
      checkSandwichLeave(newStartDate, targetEndDate, currentLT).then(sandwichInfo => {
        if (sandwichInfo) {
          dispatch({
            type: type,
            payload: {
              sandwichInfo,
              showSandwichModal: true,
              isSandwichConfirmed: false,
            },
          });
        }
      });
    }
  };

  const onChangeDate = (field, value, resetSandwich = false) => {
    dispatch({
      type: type,
      payload: {
        [field]: value,
        startDateErrMsg: "",
        applyDateErrMsg: "",
        endDateErrMsg: "",
        uploadDocumentError: "",
        exceedMsg: "",
        ...(resetSandwich && { isSandwichConfirmed: false })
      },
    });
  };

  const handleSelectHalfChange = (e) => {
    dispatch({
      type: type,
      payload: {
        halfOfTheDay: e,
        halfOfTheDayErrMsg: "",
      },
    });
  };

  const handleShortLeaveTypeChange = (e) => {
    dispatch({
      type: type,
      payload: {
        shortLeaveType: e,
        shortLeaveTypeErrMsg: "",
      },
    });
  };

  const handleStartOpenChange = (open) => {
    if (!open) {
      dispatch({
        type: type,
        payload: {
          endOpen: true,
        },
      });
    }
  };

  const handleEndOpenChange = (open) => {
    dispatch({
      type: type,
      payload: {
        endOpen: open,
      },
    });
  };

  const handleCancel = (e) => {
    if (dashboardLeaveType) {
      removeSessionStorage();
      window.location.href = "/leaves";
    }
    props.reverseView();
  };

  const onEndChange = (value) => {
    const newEndDate = moment(value).toISOString();
    console.log('onEndChange triggered:', newEndDate);
    onChangeDate("endDate", newEndDate);

    // Check for sandwich leave scenario after setting end date
    const targetStartDate = startDate || (dashboardStartDate ? moment(dashboardStartDate, [dateFormat, moment.ISO_8601]).toISOString() : "");
    const currentLT = leaveType || dashboardLeaveType;
    if (currentLT && targetStartDate && newEndDate) {
      checkSandwichLeave(targetStartDate, newEndDate, currentLT).then(sandwichInfo => {
        if (sandwichInfo) {
          dispatch({
            type: type,
            payload: {
              sandwichInfo,
              showSandwichModal: true,
              isSandwichConfirmed: false,
            },
          });
        }
      });
    }
  };

  const handleEmailChange = (e) => {
    dispatch({
      type: type,
      payload: {
        emailError: null,
        emails: e,
      },
    });
  };

  const getDisabledHoursAndMinutes = (fromTime, toTime) => {
    if (!fromTime) return { disabledHours: [], disabledMinutes: [] };

    const fromMoment = moment.utc(fromTime * 1000);
    const toMoment = moment.utc(toTime * 1000);

    const maxTime = fromMoment.clone().add(2, "hours").add(30, "minutes");

    const disabledHours = [];
    const disabledMinutes = [];
    for (let i = 0; i <= 23; i++) {
      if (
        i < fromMoment.hour() ||
        (i === fromMoment.hour() && i < fromMoment.minute())
      ) {
        disabledHours.push(i);
      }
      if (i > maxTime.hour()) {
        disabledHours.push(i);
      }
    }
    if (maxTime.hour() == toMoment.hour()) {
      for (let i = maxTime.minute() + 1; i < 60; i++) {
        disabledMinutes.push(i);
      }
    }
    return { disabledHours, disabledMinutes };
  };
  return (
    <div>
      <div>
        <Toastify
          resMsg={resLeaveMsg}
          text={
            (leaveType && !dashboardLeaveType
              ? leaveValue(+leaveType)
              : !leaveType && dashboardLeaveType
                ? leaveValue(+dashboardLeaveType)
                : leaveValue(+leaveType)) + " Applied"
          }
          resMsgFail={resFailMsg}
          responseMessage={responseMessage}
        />
      </div>
      <div className="cm_breadcrumb cm_bold">
        <ul>
          <li
            style={{
              textTransform: "uppercase",
              color: "black",
              cursor: "pointer",
            }}
            onClick={handleCancel}
          >
            LEAVES RECORD
            <div className="cm_breadcrumb_arrow"></div>
          </li>

          <li>Apply Leave</li>
        </ul>
      </div>
      {miniLoader ? (
        <Loader />
      ) : (
        <>
          <form className="">
            <h3 className="mt-5 mb-5">Apply Leave </h3>
            <div
              className={`row  ${!dashboardLeaveType && leaveErMsg ? "input_error" : ""
                }`}
            >
              <div className="form-group col-md-4 col-sm-12">
                <label className=" sub">Leave Type</label>
                <Select
                  className="cm_leaves "
                  placeholder="Select Leave"
                  value={
                    leaveType
                      ? leaveType
                      : dashboardLeaveType
                        ? dashboardLeaveType
                        : "Select Leave"
                  }
                  onChange={handleSelectChange}
                >
                  {LEAVE_ARRAY.map((option) => (
                    <Option key={option.value} value={option.value}>
                      {option.label}
                    </Option>
                  ))}
                </Select>
              </div>
              <div className="form-group col-md-4 col-sm-12">
                <label className="sub"> Send To</label>
                <main className="">
                  <input
                    className={`email-input email-input-height`}
                    value={"hr@mobcoder.com"}
                    disabled
                  />
                </main>
              </div>
            </div>
            {!dashboardLeaveType && leaveErMsg ? (
              <span className="error_msg">{leaveErMsg}</span>
            ) : null}
            {((leaveType &&
              (leaveType === "6" ||
                leaveType === "7" ||
                leaveType === "8" ||
                leaveType === "9" ||
                leaveType === "10" ||
                leaveType === "15")) ||
              (dashboardLeaveType &&
                !leaveType &&
                dashboardLeaveType === "6") ||
              dashboardLeaveType === "7" ||
              dashboardLeaveType === "8" ||
              dashboardLeaveType === "9" ||
              dashboardLeaveType === "10" ||
              dashboardLeaveType === "15") && (
                <>
                  <div
                    className={`row  ${halfOfTheDayErrMsg ? "input_error" : ""}`}
                  >
                    <div className="col-md-4 col-sm-12 mt-4">
                      <label className=" sub">Half Type</label>
                      <Select
                        placeholder="Select Half Type"
                        value={halfOfTheDay ? halfOfTheDay : "Select Half Type"}
                        onChange={handleSelectHalfChange}
                      >
                        <Option value={1}>First Half Leave</Option>
                        <Option value={2}>Second Half Leave</Option>
                      </Select>
                    </div>
                  </div>{" "}
                  {halfOfTheDayErrMsg ? (
                    <span className="error_msg">{halfOfTheDayErrMsg}</span>
                  ) : null}
                </>
              )}
            <br /> <br />
            <div className={`row  ${exceedMsg ? "input_error" : ""}`}>
              <div
                className={`form-group col-md-4 col-sm-12 ${startDateErrMsg || applyDateErrMsg ? "input_error" : ""
                  }`}
              >
                <label className="sub">Start Date</label>
                <DatePicker
                  className="date-border"
                  allowClear={false}
                  disabledDate={(current) => disabledStartDate(current, leaveType || dashboardLeaveType)}
                  value={
                    !startDate && dashboardStartDate
                      ? moment(dashboardStartDate)
                      : startDate
                        ? moment(startDate)
                        : startDate
                  }
                  placeholder="Start date"
                  format={dateFormat}
                  onChange={onStartChange}
                  onOpenChange={handleStartOpenChange}
                />
                {startDateErrMsg && <ErrorMessage errMsg={startDateErrMsg} />}
                {applyDateErrMsg && <ErrorMessage errMsg={applyDateErrMsg} />}
                {exceedMsg && <ErrorMessage errMsg={exceedMsg} />}
              </div>
              {leaveType === Short_Day_Leave || (dashboardLeaveType === Short_Day_Leave && !leaveType) ? (
                <div
                  className={`form-group col-md-4 col-sm-12 ${shortLeaveTypeErrMsg ? "input_error" : ""
                    }`}
                >
                  <label className="sub">Short Leave Type</label>
                  <Select
                    className="cm_leaves"
                    placeholder="Select Short Leave Type"
                    value={shortLeaveType ? shortLeaveType : "Select Short Leave Type"}
                    onChange={handleShortLeaveTypeChange}
                    loading={loadingShortLeaveConfig}
                    disabled={loadingShortLeaveConfig || availableShortLeaveTypes.length === 0}
                  >
                    {availableShortLeaveTypes.map((option) => (
                      <Option key={option.value} value={option.value}>
                        {option.label}
                      </Option>
                    ))}
                  </Select>
                  {shortLeaveTypeErrMsg ? (
                    <span className="error_msg">{shortLeaveTypeErrMsg}</span>
                  ) : null}
                </div>
              ) : null}
              {halfLeaveValues.includes(leaveType) ||
                (!leaveType && halfLeaveValues.includes(dashboardLeaveType)) ||
                (!leaveType && dashboardLeaveType === Short_Day_Leave) ||
                leaveType === Short_Day_Leave ? (
                ""
              ) : (
                <div
                  className={`form-group col-md-4 col-sm-12 ${endDateErrMsg ? "input_error" : ""
                    }`}
                >
                  <label className="sub">End Date</label>
                  <DatePicker
                    className="date-border"
                    allowClear={false}
                    format={dateFormat}
                    disabledDate={(e) =>
                      disabledLeaveEndDate(
                        e,
                        dashboardLeaveType && !leaveType
                          ? dashboardLeaveType
                          : leaveType,
                        dashboardStartDate && !startDate
                          ? dashboardStartDate
                          : startDate,
                        props?.totalRemainingLeave,
                        assignedClientOff,
                        assignedBereavementLeaves,
                        assignedPaternalLeave,

                      )
                    }
                    value={!endDate ? endDate : moment(endDate)}
                    placeholder="End date"
                    onChange={onEndChange}
                    open={endOpen}
                    onOpenChange={handleEndOpenChange}
                  />
                  {endDateErrMsg ? (
                    <span className="error_msg">{endDateErrMsg}</span>
                  ) : null}
                </div>
              )}
            </div>
            {leaveType === Short_Day_Leave ||
              (dashboardLeaveType === Short_Day_Leave && !leaveType) ? (
              <div className="row">
                <div
                  className={`form-group col-md-4 col-sm-12 ${shortDayFromErrorMsg ? "input_error" : ""
                    }`}
                >
                  <label className="sub"> From</label>
                  <TimePicker
                    className="form-control"
                    allowClear={false}
                    disabledHours={() => [
                      0, 1, 2, 3, 4, 5, 6, 7, 20, 21, 22, 23,
                    ]}
                    format={format}
                    value={shortDayFrom ? moment.utc(shortDayFrom * 1000) : ""}
                    onChange={handleCheckInChange}
                  />
                  {shortDayFromErrorMsg ? (
                    <span className="error_msg">{shortDayFromErrorMsg}</span>
                  ) : null}
                </div>
                <div
                  className={`form-group col-md-4 col-sm-12 ${shortDayToErrorMsg ? "input_error" : ""
                    }`}
                >
                  <label className="sub">To</label>
                  <TimePicker
                    className="form-control"
                    allowClear={false}
                    format={format}
                    value={shortDayTo ? moment.utc(shortDayTo * 1000) : ""}
                    onChange={handleCheckOutChange}
                    disabledHours={() =>
                      getDisabledHoursAndMinutes(shortDayFrom, shortDayTo)
                        .disabledHours
                    }
                    disabledMinutes={() =>
                      getDisabledHoursAndMinutes(shortDayFrom, shortDayTo)
                        .disabledMinutes
                    }
                  />
                  {shortDayToErrorMsg ? (
                    <span className="error_msg">{shortDayToErrorMsg}</span>
                  ) : null}
                </div>
              </div>
            ) : (
              ""
            )}
            <div className="row">
              <div className="col-md-4 col-sm-12">
                <label className="mt-5 sub">Cc</label>
                <br />
                {emails.length > 0 ? (
                  ""
                ) : (
                  <label className="red sub">
                    * Please mention your project manager and teamlead in Cc
                  </label>
                )}
                <Select
                  showSearch
                  mode="multiple"
                  name="employeeId"
                  value={emails ? emails : "Select Cc"}
                  placeholder={"Select Cc"}
                  optionFilterProp="key"
                  filterOption={(input, option) =>
                    option.key.toLowerCase().includes(input.toLowerCase())
                  }
                  onChange={handleEmailChange}
                >
                  {!_.isEmpty(employeeList)
                    ? employeeList
                      .filter(
                        (data) =>
                          data.employeeId !==
                          localStorage.getItem("employeeId")
                      )
                      .map(
                        (employee) =>
                          employee.status == 1 && (
                            <Option
                              key={`${employee.firstName} ${employee.lastName}`}
                              value={employee.email}
                            >
                              <span>{employee.email}</span>
                            </Option>
                          )
                      )
                    : ""}
                </Select>
              </div>
            </div>
            <UploadDocument
              dispatch={dispatch}
              uploadDocument={uploadDocument}
              uploadDocumentName={uploadDocumentName}
              uploadDocumentErrMsg={uploadDocumentErrMsg || uploadDocumentError}
            />
            <div className="row">
              <div
                className={`form-group col-md-10 col-sm-12${reasonErMsg ? "input_error" : ""
                  }`}
              >
                <label className="mt-5 sub">Reason</label>
                <TextEditor
                  editorState={editorState}
                  onEditorStateChange={onEditorStateChange}
                />
                {reasonErMsg ? (
                  <span className="error_msg">{reasonErMsg}</span>
                ) : null}
              </div>
            </div>
            <div className=" submit_button_margin mb-3 mt-4">
              <button
                type="button"
                onClick={handleSubmit}
                className="btn btn-primary cm_btn3"
                disabled={miniLoader}
              >
                Submit
              </button>
              {miniLoader ? (
                <div className="mini_loader_dept leave_loader"></div>
              ) : (
                ""
              )}
              {(miniLoader || !dashboardLeaveType) && (
                <button
                  type="button"
                  className="btn btn-primary cm_btn2"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
              )}
            </div>
          </form>
        </>
      )}

      <Modal
        show={showSandwichModal}
        onHide={() => dispatch({ type, payload: { showSandwichModal: false } })}
        centered
        backdrop="static"
      >
        <Modal.Header>
          <Modal.Title>Sandwich Leave Notification</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{sandwichInfo?.message}</p>
          <p className="text-danger font-weight-bold">
            Note: All days (including the weekend) will be deducted from your leave balance.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-primary"
            onClick={() => {
              dispatch({ type: type, payload: { showSandwichModal: false, isSandwichConfirmed: true } });
            }}
          >
            I Understand, Proceed
          </button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ApplyLeave;
